class Counter {
    constructor() {
        $(window).on('scroll resize', this.checkViewport.bind(this));
        this.checkViewport(); // Also run on load
    }

    checkViewport() {
        $('.js-counter').each((_, el) => {
            const $el = $(el);
            if (this.isInViewport($el) && !$el.data('animated')) {
                this.animateCounter($el);
                $el.data('animated', true); // Mark as animated
            }
        });
    }

    isInViewport($el: JQuery<HTMLElement>): boolean {
        const offset = $el.offset();
        const top = offset ? offset.top : 0;
        const bottom = top + $el.outerHeight()!;
        const scrollTop = $(window).scrollTop()!;
        const scrollBottom = scrollTop + $(window).height()!;
        return bottom > scrollTop && top < scrollBottom;
    }

    animateCounter($el: JQuery<HTMLElement>) {
        $el.find('.js-count').each((_, el) => {
            const $count = $(el);
            const target = parseInt($count.text().replace(/\D/g, ''), 10);
            let current = 0;
            const increment = target / 100;

            const interval = setInterval(() => {
                current += increment;
                if (current >= target) {
                    current = target;
                    clearInterval(interval);
                }

                const intVal = Math.floor(current);
                const formatted = intVal.toString().length > 2
                    ? this.formatNumber(intVal)
                    : intVal.toString();

                $count.text(formatted);
            }, 15);
        });
    }

    formatNumber(num: number): string {
        const str = num.toString();
        return str.length > 2 ? str.slice(0, 2) + '.' + str.slice(2) : str;
    }
}

new Counter();
